import { saveAs } from "file-saver";
import notification from "../utils/notification";
import { baseURL } from "./api";

async function downloadFile(importId: string, filter: string = "all"): Promise<any> {
  const endpoint =
    filter === "original"
      ? `${baseURL}pipeline-import/${importId}/download-original`
      : `${baseURL}pipeline-import/${importId}/download?filter=${filter}`;

  fetch(endpoint, {
    credentials: "include",
  })
    .then(async (response) => {
      if (!response.ok) {
        const res = await response.json();
        throw res.error ? res.error : "An unknown error occurred, please try again";
      }

      // Get filename from Content-Disposition header if available
      const contentDisposition = response.headers.get("Content-Disposition");
      let fileName = importId;

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename=([^;]+)/);
        if (filenameMatch && filenameMatch[1]) {
          fileName = filenameMatch[1].trim().replace(/"/g, "");
        }
      }

      return { blob: await response.blob(), fileName };
    })
    .then(({ blob, fileName }) => saveAs(blob, fileName))
    .catch((error) => {
      notification({ title: "Error", message: error, type: "error" });
    });
}

export default downloadFile;
